import React, { useEffect, useState } from "react";
import styled, {css} from "styled-components";
import uniqid from "uniqid";
import { Breadcrumbs, FormCaption, FormGroup, Head, ImagePicker, Input, Pill, Radio, Select, SelectMultiple, StatusDot, Switch, Textarea } from "xsolla-uikit";
import PAContentBlock from "../PAContentBlock";
import '../shop.css';
import { PAinfoCollapsible } from '../uikit2';














export default function PAviItem({
  showAsPage = false,

  order = 1,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url,
  advertisement_type = null,

  name = "Xsolla Rocket Launcher",

  status = "active",
  hist
}) {
  const [state, setState] = useState({
    twoCols: false,
    action: false //users'settings''users'widget'
  });

  const handleLink = (stat = state.action) => {
    // setState({
    //   action: stat
    // });
  };

  useEffect(() => {
    let newPage = hist ? hist.match.params.keyId : null;
    return () => {};
  }, [hist, state]);

  return (

      <div
        style={{ position: "relative", height: "100%" }}
        // className="xsui-width"
        // position="relative"
      >
        {showAsPage && (
          <Breadcrumbs
            //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
            limit={6}
            items={[
              {
                label: "In-game store",
                to: "/microtransactions/"
              },
              {
                label: "Virtual items",
                to: "/microtransactions/vi"
              },
              {
                label: "Weapons",
                to: "/microtransactions/vi/group_1"
              },
              {
                label: (
                  <React.Fragment>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {name}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: 5,
                          margin: "5px 0 0 16px"
                        }}
                      >
                        <Pill
                          appearance={`${
                            status !== "draft" ? `active` : `warning`
                          } `}
                        >
                          <StatusDot
                            status={`${
                              status !== "draft" ? `enabled` : `testing`
                            } `}
                            // status="enabled"
                          >
                            {" "}
                            {status}
                          </StatusDot>
                        </Pill>
                      </div>
                    </div>
                  </React.Fragment>
                ),
                to: "/microtransactions/vi/group_1"
              }
            ]}
          />
        )}

        {!showAsPage && (
          <FormGroup
            border="xs"
            style={{
              position: "sticky",
              top: 0,
              paddingTop: 16,
              // minHeight: 44,
              background: "white",
              zIndex: 10
              // border: '1px solid red'
            }}
          >
            <Head
              // appearance="separated"
              indentation="sm"
            >
              <Breadcrumbs
                //.xsui-breadcrumbs_label {max-width: 100% !important;} //TODO: fix
                limit={6}
                items={[
                  {
                    label: (
                      <React.Fragment>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "26px"
                          }}
                        >
                          {localized_name}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: 5,
                              margin: "5px 0 0 16px"
                            }}
                          >
                            <Pill
                              appearance={`${
                                status !== "draft" ? `active` : `warning`
                              } `}
                            >
                              <StatusDot
                                status={`${
                                  status !== "draft" ? `enabled` : `testing`
                                } `}
                                // status="enabled"
                              >
                                {" "}
                                {status}
                              </StatusDot>
                            </Pill>
                          </div>
                        </div>
                      </React.Fragment>
                    ),
                    to: "/microtransactions/vi/group_1"
                  }
                ]}
              />
            </Head>
          </FormGroup>
        )}

        <div
          style={{
            position: "relative",
            flexGrow: 1,
            overflowY: "auto",
            width: '100%',
            // top: 0,
            // display: state.twoCols ? "grid" : "auto",
            // // gridTemplateColumns: "repeat(2, 1fr)",
            // gridTemplateColumns: state.twoCols ? "1fr 2.5fr" : "auto",
            // // gridTemplateRows: '200px',
            // gridColumnGap: "2%",
            // gridRowGap: "16px"
            // width: "100%"
          }}
        >
          <Anchor id="settings"/>

          <FormGroup indentation="lg">
            <FormGroup indentation="lg">
              {/* <CardNew wave={false}> */}
              {/* <ContentBlock> */}

              <PAviItemsettings
                image_url={image_url}
                order={order}
                id={id}
                sku={sku}
                localized_name={localized_name}
                prices={prices}
                virtual_currency_price={virtual_currency_price}
                default_currency={default_currency}
                enabled={enabled}
                permanent={permanent}
                advertisement_type={advertisement_type}
                name={name}
                status={status}
                hist={hist}
              />
              {/* </ContentBlock> */}
              {/* </CardNew> */}
            </FormGroup>
          </FormGroup>
        </div>
        {/* </div> */}

        {/*
{!showAsPage &&
  <div
    border="xs"
    style={{
      position: 'fixed',
      top: '96vh',
      height: '6vh',
      paddingTop: 16,
      // minHeight: 44,
      background: 'red',
      zIndex: 11,
      // border: '1px solid red'
    }}
  >
  Form Footer
</div>} */}
      </div>

  );
}

export function PAviItemsettings({
  order = 1,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url,
  advertisement_type = null,

  name = "Xsolla Rocket Launcher",
  img,
  status = "active",
  hist
}) {
  const [stateGoups, setStateGroups] = useState({
    groups: []
  });

  const [stateQs, setStateQs] = useState(1);

  const [limit, setLimit] = useState(0);
  const [currencyType, setCurrencyType] = useState("real"); //real / virtual

  const groups = [
    { label: "Weapons", value: "w" },
    { label: "Metal", value: "m" },
    { label: "Epic", value: "e" }
  ];

  const quantities = [
    { label: "Don't limit", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "Custom Number", value: 6 }
  ];

  return (
    <div style={{width: '100%'}}>
      <PAContentBlock
        wizard={true}
        style={{width: '100%'}}
        // title="General Settings"
        border="lg">
        <FormGroup indentation="lg">
          <PAinfoCollapsible
            title="Store preview"
            indentation="lg"
            isOpen={false}
          >
            <PAviPreview
              localized_name={localized_name}
              image_url={image_url}
              order={order}
              id={id}
              sku={sku}
              prices={{ USD: 1.99 }}
              virtual_currency_price={virtual_currency_price}
              default_currency={default_currency}
              enabled={enabled}
              permanent={permanent}
              advertisement_type={advertisement_type}
              name={name}
            />
          </PAinfoCollapsible>
        </FormGroup>

        <FormGroup label="Image" tooltip="Some tooltip">
          <ImagePicker
            name="image2"
            input={{
              value: image_url,
              onChange: () => this.setState({ value: null })
            }}
            url="/"
          />
        </FormGroup>

        <FormGroup label="SKU" tooltip="Some tooltip" indentation="md">
          <Input
            input={{
              value: sku
            }}
          />
        </FormGroup>

        <FormGroup label="Item code" tooltip="Some tooltip" indentation="md">
          <Input
            input={{
              value: sku
            }}
          />
        </FormGroup>

        <FormGroup label="Groups" tooltip="Some tooltip" indentation="md">
          <SelectMultiple
            name="values"
            options={groups}
            fields={{
              getAll: () => stateGoups.groups,
              push: a => setStateGroups({ groups: [...stateGoups.groups, a] }),
              remove: index => {
                const platforms = [...stateGoups.groups];
                groups.splice(index, 1);
                setStateGroups({ groups });
              }
            }}
          />
        </FormGroup>

        <FormGroup
          label="Item name | English"
          tooltip="Some tooltip"
          indentation="md"
        >
          <Input
            input={{
              value: localized_name
            }}
          />
        </FormGroup>

        <FormGroup
          label="Short description | English"
          tooltip="Some tooltip"
          indentation="md"
        >
          <Textarea
            name="basic"
            input={{
              value: null,
              onChange: () => {
                void 0;
              }
            }}
          />
        </FormGroup>

        <FormGroup
          label="Description | English"
          tooltip="Some tooltip"
          indentation="md"
        >
          <Textarea
            name="basic"
            input={{
              value: null,
              onChange: () => {
                void 0;
              }
            }}
          />
        </FormGroup>
      </PAContentBlock>

      <PAContentBlock wizard={true} title="Preferences" border="lg">
        <FormGroup label="Label" tooltip="Some tooltip" indentation="md">
          <SelectMultiple
            name="values"
            options={groups}
            fields={{
              getAll: () => stateGoups.groups,
              push: a => setStateGroups({ groups: [...stateGoups.groups, a] }),
              remove: index => {
                const platforms = [...stateGoups.groups];
                groups.splice(index, 1);
                setStateGroups({ groups });
              }
            }}
          />
        </FormGroup>

        <FormGroup
          label="Item property"
          tooltip="Some tooltip"
          indentation="md"
        >
          <SelectMultiple
            name="values"
            options={groups}
            fields={{
              getAll: () => stateGoups.groups,
              push: a => setStateGroups({ groups: [...stateGoups.groups, a] }),
              remove: index => {
                const platforms = [...stateGoups.groups];
                groups.splice(index, 1);
                setStateGroups({ groups });
              }
            }}
          />
        </FormGroup>

        <FormGroup
          label="Tags | English"
          tooltip="Some tooltip"
          indentation="md"
        >
          <Input
            input={{
              value: ""
            }}
          />
        </FormGroup>
      </PAContentBlock>

      <PAContentBlock wizard={true} title="Pricing" border="xs">
        <FormGroup label="Sell in:" tooltip="Some tooltip" border="lg">
          <FormGroup indentation="xs">
            <Radio
              name="rc"
              label="Real currency"
              radioValue={"real"}
              input={{
                value: currencyType,
                onChange: () => {
                  setCurrencyType("real");
                }
              }}
            />
          </FormGroup>
          <FormGroup indentation="xs">
            <Radio
              name="vi"
              radioValue={"virtual"}
              label="Virtual currency"
              input={{
                value: currencyType,
                onChange: () => {
                  setCurrencyType("virtual");
                }
              }}
            />
          </FormGroup>

          {currencyType === "real" && (
            <div className="">
              <FormGroup>
                <div className="xsui-form-group__entry">
                  <div className="ui-form__prices-selector">
                    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                      <div className="xsui-form-group__entry">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start"
                          }}
                        >
                          <div style={{ width: 140, flexShrink: 0 }}>
                            <div className="xsui-select">
                              <div className="xsui-dropdown">
                                <div style={{ display: "block" }}>
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                      display: "block"
                                    }}
                                  >
                                    <button
                                      name="prices_array[0].name"
                                      value="USD"
                                      placeholder="Select"
                                      className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only xsui-input--dock-right"
                                      type="button"
                                      data-id="prices_array[0].name"
                                      data-value="USD"
                                    >
                                      USD
                                    </button>
                                    <div className="xsui-input__icon">
                                      <i
                                        className="xsui-icon xsui-icon-dropdown-select"
                                        style={{
                                          fontSize: 24,
                                          color: "inherit"
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div />
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "100%", marginLeft: "-1px" }}>
                            <div style={{ display: "block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  display: "block"
                                }}
                              >
                                <input
                                  min={0}
                                  step="any"
                                  name="prices_array[0].value"
                                  placeholder="Price"
                                  className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--dock-left"
                                  type="number"
                                  data-id="prices_array[0].value"
                                  data-value="1.99"
                                  defaultValue="1.99"
                                />
                              </div>
                            </div>
                          </div>
                          <div style={{ marginLeft: 8, flexShrink: 0 }}>
                            <button
                              data-id="price-selector.0.button"
                              data-value="add"
                              className="xsui-button xsui-button--appearance-square xsui-button--size-md"
                              type="button"
                            >
                              <div className="xsui-button__wrapper">
                                <div className="xsui-button__content">
                                  <i
                                    className="xsui-icon xsui-icon-plus"
                                    style={{ fontSize: 24, color: "inherit" }}
                                  />
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </FormGroup>
              <FormGroup
                label="Default currency"
                tooltip="Some tooltip"
                indentation="xs"
              >
                <div className="l_flex">
                  <SelectMultiple
                    name="values"
                    options={groups}
                    fields={{
                      getAll: () => stateGoups.groups,
                      push: a =>
                        setStateGroups({ groups: [...stateGoups.groups, a] }),
                      remove: index => {
                        const platforms = [...stateGoups.groups];
                        groups.splice(index, 1);
                        setStateGroups({ groups });
                      }
                    }}
                  />
                </div>
              </FormGroup>
            </div>
          )}

          {currencyType === "virtual" && (
            <div className="">
              <FormGroup
                // label="Price in virtual currency"
                indentation="xs"
              >
                {/* <FormCaption label="golden coins"> */}

                <div className="xsui-form-group__entry">
                  <div className="ui-form__prices-selector">
                    <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-sm">
                      <div className="xsui-form-group__entry">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start"
                          }}
                        >
                          <div style={{ width: 140, flexShrink: 0 }}>
                            <div className="xsui-select">
                              <div className="xsui-dropdown">
                                <div style={{ display: "block" }}>
                                  <div
                                    style={{
                                      position: "relative",
                                      width: "100%",
                                      display: "block"
                                    }}
                                  >
                                    <button
                                      name="prices_array[0].name"
                                      value="USD"
                                      placeholder="Select"
                                      className="xsui-input xsui-input--size-md xsui-input--appearance-primary
                                    xsui-input--offset-right xsui-input--read-only xsui-input--dock-right"
                                      type="button"
                                      data-id="prices_array[0].name"
                                      data-value="USD"
                                    >
                                      Gold coins
                                    </button>
                                  </div>
                                </div>
                                <div />
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "100%", marginLeft: "-1px" }}>
                            <div style={{ display: "block" }}>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  display: "block"
                                }}
                              >
                                <input
                                  min={0}
                                  step="any"
                                  name="prices_array[0].value"
                                  placeholder="Price"
                                  className="xsui-input xsui-input--size-md xsui-input--appearance-primary xsui-input--dock-left"
                                  type="number"
                                  data-id="prices_array[0].value"
                                  data-value="1.99"
                                  defaultValue="1.99"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* </FormCaption> */}
              </FormGroup>
            </div>
          )}
        </FormGroup>

        {/* <FormGroup label="" border="lg">
          <FormGroup label="" indentation="xs">
            <Switch
              disabled={true}
              name="switch_1"
              // label="Limit purchases"
              label="Limit the quantity that one user can purchase"
              tooltip=""
              input={{
                value: false,
                onChange: ()=>{void(0)}
              }}
              // sublabel={
              //   <div>Limit the quantity that one user can purchase</div>
              // }
            />
          </FormGroup>
          <FormGroup label="" indentation="md">
            <Notification  status="info" icon={true} float={true}>
              To access this option, turn on <a href="">Store user data</a> in Xsolla.
            </Notification>
          </FormGroup>
        </FormGroup> */}

        <FormGroup label="">
          <FormGroup label="" indentation="xs">
            <Switch
              name="switch_1"
              // label="Limit purchases"
              label="Limit by quantity"
              tooltip=""
              input={{
                value: limit ? true : false,
                onChange: () => {
                  if (!limit) {
                    setStateQs(1);
                  }
                  setLimit(limit ? false : 1);
                }
              }}
              // sublabel={
              //   <div>Limit the quantity that one user can purchase</div>
              // }
            />
          </FormGroup>

          {!!limit && stateQs >= 6 && (
            <FormCaption label="item can only be purchased by a given user">
              <div
              // style={{width: 56}}
              >
                <Input
                  input={{ name: "caption", value: 6, onChange: () => void 0 }}
                  placeholder="Count"
                  inline={true}
                  focused={true}
                  // size="xs"
                />
              </div>
            </FormCaption>
          )}

          {!!limit && stateQs < 6 && (
            <FormCaption label="item can only be purchased by a given user">
              <div
              // style={{width: 56}}
              >
                <Select
                  disabled={false}
                  name="Select version to customize:"
                  options={[...quantities]}
                  searchable={false}
                  autosize={false}
                  size="md"
                  input={{
                    name: "Qantity",
                    value: stateQs,
                    onChange: a => {
                      setStateQs(a);
                      if (!a) {
                        setLimit(0);
                      }
                    }
                  }}
                />
              </div>
            </FormCaption>
          )}
        </FormGroup>
      </PAContentBlock>

      <PAContentBlock wizard={true} title="" border={false}>
        <Switch
          name="switch_1"
          label="Show item in Store"
          tooltip=""
          input={{
            value: true,
            onChange: () => {
              void 0;
            }
          }}
        />
      </PAContentBlock>
    </div>
  );
}

export const PAviPreview = ({
  order = 1,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url,
  advertisement_type = null,
}) => {
  return (
    <section
      className="grid-item grid-item-0"
      data-good="template"
      data-template="null"
      style={{ zIndex: 0 }}
    >
      <div className="item_container">
        <div className="item">
          <div className="item_inner">
            <div
              className="c_pic"
              data-good="pic"
              style={{ backgroundImage: `url(${image_url})` }}
            />
            <div
              className="c_txt"
              style={{
                transition: "transform 200ms ease 0s, opacity 200ms ease 0s",
                opacity: 1,
                transform: "translateX(0px) translateY(0px)"
              }}
            >
              <div className="c_price_block">
                <div className="c-txt0">
                  <div className="c_price_new">
                    <div className="c_txt1_price_new" data-good="price_new">
                      <div className="text-block-2"
                        style={{color: '#FF005B',
                      borderColor: '#FF005B',}}
                      >$1400.99</div>
                    </div>
                  </div>

                  {/* <div className="c_txt1_price old">
<div data-good="price">$  € 39.00</div>
<div className="price_old_strike"../>
</div> */}
                </div>

                {/* <div className="c_txt1_price_count" data-good="price_count">
        <div>Sale price</div>
      </div> */}
              </div>
              <div className="c-txt1">
                <div className="c_txt1_name" data-good="name">
                  {localized_name}
                </div>
              </div>
              <div className="c-txt2">
                <div className="c_txt1_desc" data-good="desc">
                  Scale100_Mon_Legs
                </div>
              </div>
            </div>
          </div>
          <div className="item_buts">
            <div
              className="buts_main_feat"
              style={{
                transition: "transform 200ms ease 0s, opacity 200ms ease 0s",
                opacity: 1,
                transform: "translateX(0px) translateY(0px)"
              }}
            >
              <div className="buts_main_preorder hidden">
                <div className="but but_main"
                  style={{backgroundColor: '#FF005B',borderColor: '#FF005B'}}
                >
                  <div>Pre-Order</div>
                </div>
              </div>
              <div className="buts_main_buy">
                <div className="but but_main"
                style={{backgroundColor: '#FF005B',borderColor: '#FF005B'}}
                >
                  <div>Buy Now</div>
                </div>
                {/* <div
                  className="but"
                  data-ix="cart-show"
                  style={{
                    transition:
                      "color 0.2s ease 0s, border-color 0.2s ease 0s, background-color 0.2s ease 0s"
                  }}
                >
                  <img
                    className="icon_cart"
                    src="../Xsolla Shop_files/5993b0446c6b200001c535db_Cart.svg"
                  />
                </div> */}
              </div>
            </div>
          </div>
          <div
            className="c_bg_feat"
            style={{
              transition: "transform 200ms ease 0s, opacity 200ms ease 0s",
              opacity: "1",
              transform: "scale(1)",
              backgroundColor: 'black',
            }}
          >
            <div
              className="c_bg_blur"
              data-good="pic_bg"
              style={{

                backgroundImage:
                  `url(${image_url})`
              }}
            />
          </div>
          <div className="but_fav" data-badge="fav">
            <div className="but_icon">
              <img
                src="../Xsolla Shop_files/5982720fd8d584000149c4ad_but_star.svg"
                width={13}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export function Anchor({ id = uniqid() }) {
  return (
    <div>
      <a id={id}></a>
    </div>
  );
}

const CSSedit = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  background: #0000007a;
  transition: opacity 150ms ease-in-out;
  opacity: 0;
  z-index: 1000;
  &:hover {
    opacity: 1;
  }
`;
